<style>
.padding_10 {
  padding: 0px !important;
}
</style>
<template>
  <div>
    <div v-if="submit_loader" style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      ">
      <div class="text-xs-center" large></div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 sm8 md8 class="text-xs-left">
        </v-flex>
      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-card>
            <v-form id="create_coupon" data-vv-scope="createCoupon" @submit.prevent="validateBeforeSubmit('createCoupon')">
              <v-card-text>
                <v-layout row wrap>
                  <!-- <v-flex xs12 md12 lg12> -->
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Coupon Code <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="coupon_code" v-model="coupon_object.coupon_code" label="Coupon Code"
                      v-validate="'required'" :error-messages="errors.collect('createCoupon.coupon_code')" clearable
                      solo flat maxlength="15" @input.native="formatCouponCode" data-vv-as="Coupon Code"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Coupon Desc <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="coupon_description" v-model="coupon_object.coupon_description"
                      label="Description" v-validate="'required'"
                      :error-messages="errors.collect('createCoupon.coupon_description')" clearable solo flat
                      data-vv-as="Coupon Description"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Max User Count <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="max_user_count" v-model="coupon_object.max_user_count" label="Max User Count"
                      v-validate="'required|numeric'"
                      :error-messages="errors.collect('createCoupon.max_user_count')" clearable solo flat maxlength="6"
                      @keypress="allowFloat($event, 'max_user_count')" @input="preventDoubleDot('max_user_count')" data-vv-as="Max User Count"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Valid From <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuFrom" v-model="coupon_object.menu_valid_from" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="coupon_object.valid_from"
                            name="valid_from"
                            v-validate="'required'"
                            data-vv-name="valid_from"
                            :error-messages="errors.collect('createCoupon.valid_from')"
                            label="Select Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            flat
                          ></v-text-field>
                        </template>

                        <v-date-picker v-model="coupon_object.valid_from" no-title scrollable :min="current_date">
                          <v-spacer></v-spacer>

                          <v-btn text color="primary" @click="coupon_object.valid_from = null">Clear</v-btn>
                          <v-btn text color="primary" @click="coupon_object.menu_valid_from = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuFrom.save(coupon_object.valid_from)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>
                  
                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Valid Till <span style="color: red;">*</span></label>
                    </v-flex>

                    <v-flex xs12 md12 lg12 style="display: flex; flex-wrap: wrap; padding:0px !important">
                      <v-menu ref="menuTill" v-model="coupon_object.menu_valid_till" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :value="coupon_object.valid_till" label="Select Date" readonly v-bind="attrs"
                            v-on="on" solo flat></v-text-field>
                        </template>

                        <v-date-picker
                            v-model="coupon_object.valid_till"
                            no-title
                            scrollable
                            :min="coupon_object.valid_from || current_date"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="coupon_object.valid_till = null">Clear</v-btn>
                          <v-btn text color="primary" @click="coupon_object.menu_valid_till = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menuTill.save(coupon_object.valid_till)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-flex>
                  <input type="hidden" name="valid_till" v-validate="'required'" v-model="coupon_object.valid_till"
                    data-vv-as="Valid Till" />

                  <v-flex xs12 sm6 md3 lg3>
                    <label>Allow User Id <span style="color: red;">*</span></label>
                    <v-text-field name="allowed_user_id" v-model="coupon_object.allowed_user_id"
                      label="Allow User Id" v-validate="'required'"
                      :error-messages="errors.collect('createCoupon.allowed_user_id')" clearable solo flat
                      data-vv-as="Allow User Id"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <label>Is Limited <span style="color: red;">*</span></label>
                    <v-autocomplete :items="[
                      { name: 'Choose', id: '' },
                      { name: '1', id: 1 },
                      { name: '0', id: 0 },
                    ]" name="Is Limited" label="Choose" v-model="coupon_object.is_limited" item-text="name"
                      item-value="id" v-validate="'required'" data-vv-name="is_limited" data-vv-scope="createCoupon"
                      solo flat :error-messages="errors.collect('createCoupon.is_limited')" data-vv-as="Is Limited">
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Coupon Limit Upto <span v-if="coupon_object.is_limited == 1" style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field 
                      name="coupon_limit_upto"
                      v-model="coupon_object.coupon_limit_upto"
                      label="Coupon Limit Upto"
                      v-validate="coupon_object.is_limited == 1 ? 'required|decimal' : 'decimal'"
                      :error-messages="errors.collect('createCoupon.coupon_limit_upto')"
                      clearable
                      solo
                      flat
                      maxlength="6"
                      @keypress="allowFloat($event, 'coupon_limit_upto')"
                      @input="preventDoubleDot('coupon_limit_upto')"
                      data-vv-as="Coupon Limit Upto"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Min Total Amount <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="min_total_amount" v-model="coupon_object.min_total_amount"
                      label="Min Total Amount" v-validate="'required|decimal|min_value:1'"
                      :error-messages="errors.collect('createCoupon.min_total_amount')" clearable solo flat
                      maxlength="6" @keypress="allowFloat($event, 'min_total_amount')" @input="preventDoubleDot('min_total_amount')"
                      data-vv-as="Min Total Amount"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <label>Discount Type <span style="color: red;">*</span></label>
                    <v-autocomplete :items="[
                      { name: 'Choose', id: '' },
                      { name: 'amount', id: 'amount' },
                      { name: 'percentage', id: 'percentage' },
                      { name: 'item', id: 'item' },
                    ]" name="Discount Type" label="Choose" v-validate="'required'"
                      v-model="coupon_object.discount_type" @change="onDiscountTypeChange"
                      item-text="name" item-value="id" solo flat
                      data-vv-name="discount_type" data-vv-scope="createCoupon"
                      :error-messages="errors.collect('createCoupon.discount_type')" data-vv-as="Discount Type">
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Discount Value <span v-if="coupon_object.discount_type !== 'item'" style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field name="discount_value" v-model="coupon_object.discount_value" label="Discount Value"
                      :disabled="coupon_object.discount_type === 'item'"
                      v-validate="coupon_object.discount_type === 'item' ? '' : 'required|decimal'"
                      :error-messages="errors.collect('createCoupon.discount_value')" clearable solo flat maxlength="6"
                      @keypress="allowFloat($event, 'discount_value')"
                      @input="preventDoubleDot('discount_value')"
                      data-vv-as="Discount Value"></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <v-flex>
                      <label>Discount Upto <span style="color: red;">*</span></label>
                    </v-flex>
                    <v-text-field
                      name="discount_upto"
                      v-model="coupon_object.discount_upto"
                      label="Discount Upto"
                      clearable
                      solo
                      flat
                      maxlength="6"
                      @keypress="allowFloat($event, 'discount_upto')"
                      @input="preventDoubleDot('discount_upto')"
                    ></v-text-field>
                    <!-- :rules="[validateDiscountUpto]" -->
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <label>City <span style="color: red;">*</span></label>
                    <v-autocomplete
                      :items="city_list"
                      name="city_id"
                      label="Choose"
                      v-model="coupon_object.city_id"
                      item-text="name"
                      item-value="id"
                      :item-disabled="isCityOptionDisabled"
                      v-validate="'required'"
                      data-vv-name="city_id"
                      data-vv-scope="createCoupon"
                      multiple
                      chips
                      solo
                      flat
                      :error-messages="errors.collect('createCoupon.city_id')"
                      data-vv-as="City"
                    >
                    </v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 lg3>
                    <label>Line <span style="color: red;">*</span></label>
                    <v-autocomplete :items="line_list" name="line_id" label="Choose" v-model="coupon_object.line_id" item-text="line"
                      item-value="id" :item-disabled="isLineOptionDisabled" v-validate="'required'" data-vv-name="line_id" data-vv-scope="createCoupon"
                      multiple chips solo flat :error-messages="errors.collect('createCoupon.line_id')" data-vv-as="Line">
                    </v-autocomplete>
                  </v-flex>
                  
                  <v-flex xs12 sm6 md6 lg6 style="display: flex; justify-content: flex-end; align-items: anchor-center; flex-wrap: nowrap;">
                      <v-btn color="primary" small :disabled="submit_loader" type="submit">
                        Create
                      </v-btn>
                      <v-btn flat small to="/coupon-code" @click="reloadPage">Cancel</v-btn>
                  </v-flex>
                  <!-- </v-flex> -->
                </v-layout>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small :disabled="submit_loader" type="submit">
                  Create
                </v-btn>
                <v-btn flat small to="/coupon-code" @click="reloadPage">Cancel</v-btn>
              </v-card-actions> -->
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar :color="snackBar.color" :top="snackBar.top" :bottom="snackBar.bottom" :left="snackBar.left"
        :right="snackBar.right" v-model="snackBar.show">
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import axios from 'axios';

  export default {
    name: "CreateCoupon",

    props: {
      prefillData: {
        type: Object,
        default: null,
      },
    },

    data() {
      const today = new Date().toISOString().substr(0, 10);

      return {
        valid: false,
        submit_loader: false,
        is_prefill_applying: false,

        current_date: today,

        coupon_object: {
          coupon_code: null,
          coupon_description: null,
          max_user_count: null,

          valid_from: today,
          menu_valid_from: false,

          valid_till: today,
          menu_valid_till: false,

          allowed_user_id: null,
          is_limited: null,
          coupon_limit_upto: 0,
          min_total_amount: null,

          discount_type: null,
          discount_value: null,
          discount_upto: null,
          city_id: [],
          line_id: [],
        },

        city_list: [],
        line_list: [],

        snackBar: {
          show: false,
          message: "",
          color: "",
          top: true,
          right: true,
        },
      };
    },

    watch: {
      prefillData(newVal) {
        if (newVal) {
          const prefillCity = newVal.city_id != null ? newVal.city_id : newVal.city;
          const prefillLine = newVal.line_id != null ? newVal.line_id : newVal.line;

          this.coupon_object.coupon_code = newVal.coupon_code || null;
          this.coupon_object.coupon_description = newVal.coupon_description || null;
          this.coupon_object.max_user_count = newVal.max_user_count || null;
          this.coupon_object.valid_from = newVal.valid_from || this.current_date;
          this.coupon_object.valid_till = newVal.valid_till || this.current_date;
          this.coupon_object.allowed_user_id = newVal.allowed_user_id || null;
          this.coupon_object.is_limited = newVal.is_limited != null ? newVal.is_limited : null;
          this.coupon_object.coupon_limit_upto = newVal.coupon_limit_upto || 0;
          this.coupon_object.min_total_amount = newVal.min_total_amount || null;
          this.coupon_object.discount_type = newVal.discount_type || null;
          this.coupon_object.discount_value = newVal.discount_value || null;
          this.coupon_object.discount_upto = newVal.discount_upto || null;
          this.is_prefill_applying = true;
          this.coupon_object.city_id = this.sanitizeAllSelection(this.normalizeToStringArray(prefillCity));
          this.coupon_object.line_id = [];

          this.getMetroLines().finally(() => {
            this.coupon_object.line_id = this.sanitizeAllSelection(this.normalizeToStringArray(prefillLine));
            this.is_prefill_applying = false;
          });

          if (this.coupon_object.city_id.includes('0') && this.coupon_object.city_id.length > 1) {
            this.coupon_object.city_id = ['0'];
          }

          if (this.coupon_object.line_id.includes('0') && this.coupon_object.line_id.length > 1) {
            this.coupon_object.line_id = ['0'];
          }

          // Scroll to form
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      'coupon_object.city_id'(val) {
        const sanitized = this.sanitizeAllSelection(val);

        if (JSON.stringify(sanitized) !== JSON.stringify(val || [])) {
          this.coupon_object.city_id = sanitized;
          return;
        }

        if (this.is_prefill_applying) {
          return;
        }

        this.coupon_object.line_id = [];
        this.getMetroLines();
      },
      'coupon_object.line_id'(val) {
        const sanitized = this.sanitizeAllSelection(val);

        if (JSON.stringify(sanitized) !== JSON.stringify(val || [])) {
          this.coupon_object.line_id = sanitized;
          return;
        }
      },
    },

    methods: {
      reloadPage() {
        window.location.reload();
      },
      normalizeToStringArray(value) {
        if (value == null || value === '') return [];

        if (Array.isArray(value)) {
          return value
            .filter((item) => item != null && item !== '')
            .map((item) => String(item));
        }

        if (typeof value === 'string' && value.includes(',')) {
          return value
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
            .map((item) => {
              const v = String(item).trim();
              return v.toLowerCase() === 'all' ? '0' : v;
            });
        }

        const singleValue = String(value).trim();
        return [singleValue.toLowerCase() === 'all' ? '0' : singleValue];
      },
      sanitizeAllSelection(values) {
        const arr = Array.isArray(values) ? values : [];
        const normalized = arr
          .filter((item) => item != null && item !== '')
          .map((item) => String(item));

        if (normalized.includes('0') && normalized.length > 1) {
          return ['0'];
        }

        return normalized;
      },
      isAllSelected(values) {
        const arr = Array.isArray(values) ? values : [];
        return arr.some((item) => {
          const v = String(item).trim().toLowerCase();
          return v === '0' || v === 'all';
        });
      },
      isCityOptionDisabled(item) {
        return this.isAllSelected(this.coupon_object.city_id) && String(item.id) !== '0';
      },
      isLineOptionDisabled(item) {
        return this.isAllSelected(this.coupon_object.line_id) && String(item.id) !== '0';
      },
      getCityList() {
        axios.get(
          `${process.env.VUE_APP_API_URL}/api/v1/get-city-list`,
          { headers: this.$headers }
        )
          .then((response) => {
            if (response.data && response.data.status === 1 && Array.isArray(response.data.data)) {
              this.city_list = [
                { id: '0', name: 'All' },
                ...response.data.data.map((item) => ({
                  id: String(item.id),
                  name: item.name,
                }))
              ];
            } else {
              this.city_list = [{ id: '0', name: 'All' }];
            }
          })
          .catch(() => {
            this.city_list = [{ id: '0', name: 'All' }];
          });
      },
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this[scope]();
          } else {
            this.snackBar.message = "Please fill all required fields correctly.";
            this.snackBar.show = true;
          }
        });
      },
      formatCouponCode(e) {
        const val = e.target.value;
        const cleaned = val.toUpperCase().replace(/[^A-Z0-9_]/g, "");
        this.coupon_object.coupon_code = cleaned;
      },
      allowFloat(e, field) {
        const char = String.fromCharCode(e.keyCode || e.which);
        const value = this.coupon_object[field] || "";

        if (/^[0-9]$/.test(char)) return;

        if (char === '.' && !value.includes('.')) return;

        e.preventDefault();
      },

      preventDoubleDot(field) {
        let v = this.coupon_object[field] || "";
        const firstDot = v.indexOf(".");
        const lastDot = v.lastIndexOf(".");

        if (firstDot !== lastDot) {
          this.coupon_object[field] = v.replace(/\.(?=.*\.)/, "");
        }
      },
      validateDiscountUpto(value) {
        if (this.coupon_object.discount_type !== 'percentage') return true;

        const discountValue = parseFloat(this.coupon_object.discount_value);
        const discountUpto = parseFloat(value);

        if (isNaN(discountValue) || isNaN(discountUpto)) return true;

        if (discountUpto < discountValue) {
          return "Discount Upto cannot be less than Discount Value";
        }

        return true;
      },
      onDiscountTypeChange(val) {
        if (val === 'item') {
          this.coupon_object.discount_upto = 1;
          this.coupon_object.discount_value = 0;
        }
      },
      getMetroLines() {
        const selectedCities = this.sanitizeAllSelection(this.coupon_object.city_id);
        const cityIdsCsv = this.isAllSelected(selectedCities)
          ? 'All'
          : selectedCities.filter((id) => id !== '0').join(',');

        const requestConfig = {
          headers: this.$headers,
          params: cityIdsCsv ? { city_id: cityIdsCsv } : {},
        };

        return axios.get(
          `${process.env.VUE_APP_API_URL}/api/v4/get-metro-lines`,
          requestConfig
        )
          .then((response) => {
            if (response.data && response.data.status === 1 && Array.isArray(response.data.data)) {
              this.line_list = [
                { id: '0', line: 'All' },
                ...response.data.data.map((item) => ({
                  id: String(item.id),
                  line: `${item.code} - ${item.name}`,
                }))
              ];
            } else {
              this.line_list = [{ id: '0', line: 'All' }];
            }
          })
          .catch(() => {
            this.line_list = [{ id: '0', line: 'All' }];
          });
      },
      createCoupon() {
        this.submit_loader = true;
        const selectedCityIds = this.sanitizeAllSelection(this.coupon_object.city_id);
        const selectedLineIds = this.sanitizeAllSelection(this.coupon_object.line_id);

        const cityPayload = this.isAllSelected(selectedCityIds)
          ? 'All'
          : selectedCityIds
            .filter((id) => id !== '0')
            .join(',');

        const linePayload = this.isAllSelected(selectedLineIds)
          ? 'All'
          : selectedLineIds
            .filter((id) => id !== '0')
            .join(',');

        const payload = {
          coupon_code: this.coupon_object.coupon_code,
          coupon_description: this.coupon_object.coupon_description,
          max_user_count: this.coupon_object.max_user_count,
          valid_from: this.coupon_object.valid_from,
          valid_till: this.coupon_object.valid_till,
          allowed_user_id: this.coupon_object.allowed_user_id,
          is_limited: this.coupon_object.is_limited,
          coupon_limit_upto: this.coupon_object.coupon_limit_upto,
          min_total_amount: this.coupon_object.min_total_amount,
          discount_type: this.coupon_object.discount_type,
          discount_value: this.coupon_object.discount_value,
          discount_upto: this.coupon_object.discount_upto,
          city_id: cityPayload || null,
          line_id: linePayload || null,
        };

        axios.post(
          `${process.env.VUE_APP_API_URL}/api/v1/insert-coupon`,
          payload,
          { headers: this.$headers }
        )
          .then((response) => {
            if (response.data.status == 1) {

              this.snackBar.message = response.data.message;
              this.snackBar.show = true;

              window.location.reload();

            } else {
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            }

          })
          .finally(() => {
            this.submit_loader = false;
          });
      }
    },
    mounted() {
      this.current_date = moment().format("YYYY-MM-DD");
      this.getCityList();
      this.getMetroLines();
    }
  };

</script>
